/**
 * @desc SKU审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductSkuApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/skuApproval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
